"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var authenticity_token_1 = __importDefault(require("../../ProductsApp/ducks/authenticity-token"));
var is_admin_1 = __importDefault(require("../../ProductsApp/ducks/is-admin"));
var url_1 = __importDefault(require("../../ProductsApp/ducks/url"));
var content_1 = __importDefault(require("../../ProductsApp/ducks/content"));
var menu_1 = __importDefault(require("../../ProductsApp/ducks/menu"));
var location_data_1 = __importDefault(require("../../ProductsApp/ducks/location-data"));
var breadcrumbs_1 = __importDefault(require("../../ProductsApp/ducks/breadcrumbs"));
var connected_react_router_1 = require("connected-react-router");
var history_1 = __importDefault(require("../../common/Router/history"));
var site_key_1 = __importDefault(require("../ducks/site-key"));
var rootReducer = (0, redux_1.combineReducers)({
    router: (0, connected_react_router_1.connectRouter)(history_1.default),
    url: url_1.default,
    authenticityToken: authenticity_token_1.default,
    siteKey: site_key_1.default,
    isAdmin: is_admin_1.default,
    breadcrumbs: breadcrumbs_1.default,
    menu: menu_1.default,
    content: content_1.default,
    locationData: location_data_1.default,
    isMobile: function (state) {
        if (state === void 0) { state = false; }
        return state;
    },
    path: function (state) {
        if (state === void 0) { state = ''; }
        return state;
    },
    type: function (state) {
        if (state === void 0) { state = ''; }
        return state;
    },
});
exports.default = rootReducer;
